import { Component, signal, WritableSignal, AfterViewInit, DestroyRef, inject, ViewChild, OnDestroy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SHARED_MODULES } from '../../../shared.';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';
import { PhIconComponent } from '../ph-icon/ph-icon.component';
import { AllPlanogramChatsComponent } from '../all-planogram-chats/all-planogram-chats.component';
import { HumanNumberPipe } from '../../pipes/human-number.pipe';
import { SocketService, SocketGroup } from '../../services/socket.service';
import { SessionService } from '../../services/session.service';
import { IOpenChatEvent } from '../../models/chat';
import { Utils } from '../../services/utils.service';

@Component({
	selector: 'app-all-planogram-chats-widget',
	templateUrl: './all-planogram-chats-widget.component.html',
	styleUrls: ['./all-planogram-chats-widget.component.scss'],
	imports: [
		...SHARED_MODULES,
		PhIconWrapperComponent,
		PhIconComponent,
		HumanNumberPipe,
		AllPlanogramChatsComponent
	]
})
export class AllPlanogramChatsWidgetComponent implements AfterViewInit, OnDestroy {

    openEvent: IOpenChatEvent = null;
	opened: WritableSignal<boolean> = signal<boolean>(false);
	unreadCount: WritableSignal<number> = signal<number>(0);

	private destroyRef = inject(DestroyRef);
	private socketService = inject(SocketService);
    private sessionService = inject(SessionService);

	ngAfterViewInit(): void {
		this.socketService.addSubscription(SocketGroup.ChatList);
		this.socketService.chatListUnreadCount
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((data: { unread: number }): void => {
				this.unreadCount.set(data.unread);
			});

        this.sessionService.openChat$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data: { chatId: number, focusMessageId?: number }): void => {
                if (Utils.isNullOrUndefined(data?.chatId)) return;
                this.opened.set(true);
                this.openEvent = data;
            });
	}

	onOpen(): void {
		this.opened.set(true);
	}

	onClose(): void {
        this.openEvent = null;
		this.opened.set(false);
	}
    
    ngOnDestroy(): void {
        this.socketService.deleteSubscription(SocketGroup.ChatList);
    }
}
